import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Send } from 'lucide-react'
import { getDisplayName } from '../lib/owner'

// Thin comment thread beneath a capture. Plain text only — no
// quote-reply, no images, no edit/unsend. Each row shows the
// commenter's name + the body. Compose row at the bottom posts on
// submit and clears.
export default function MomentsComments({ captureId, viewerId, comments = [], locale = 'en', onSubmit }) {
  const { t } = useTranslation()
  const [draft, setDraft] = useState('')
  const [posting, setPosting] = useState(false)

  const submit = async (e) => {
    e?.preventDefault?.()
    const text = draft.trim()
    if (!text || posting) return
    setPosting(true)
    try {
      await onSubmit?.(captureId, text)
      setDraft('')
    } finally {
      setPosting(false)
    }
  }

  return (
    <div className="mt-2 space-y-1.5">
      {comments.map((c) => {
        const isMe = c.user_id === viewerId
        const name = isMe ? t('moments.you') : (getDisplayName(c.user_id, locale) || '')
        return (
          <div key={c.id} className="text-xs leading-snug">
            <span dir="auto" className="me-1 font-semibold opacity-80">{name}</span>
            <span dir="auto" className="opacity-90">{c.body}</span>
          </div>
        )
      })}
      <form onSubmit={submit} className="flex items-center gap-2 pt-1">
        <input
          dir="auto"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder={t('moments.commentPlaceholder')}
          className="flex-1 rounded-full border border-neutral-200 bg-neutral-50 px-3 py-1.5 text-xs outline-none focus:border-rose-400 dark:border-neutral-700 dark:bg-neutral-900"
          maxLength={300}
        />
        <button
          type="submit"
          disabled={!draft.trim() || posting}
          className="grid h-7 w-7 place-items-center rounded-full bg-rose-500 text-white disabled:opacity-50"
          aria-label={t('moments.sendComment')}
        >
          <Send className="h-3.5 w-3.5" />
        </button>
      </form>
    </div>
  )
}
